import React, { useState } from "react";
import { toast } from "react-toastify";
import "./style.css";

const GeneratedCodes = ({ codes }) => {
  const [copied, setCopied] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);

  if (!codes || codes.length === 0) {
    return null;
  }

  // ✅ Safe clipboard copy (fallback for mobile)
  const safeCopyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // fallback for older browsers & iOS Safari
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.top = "-1000px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
    } catch (err) {
      toast.error("Kopyalama başarısız oldu, lütfen tekrar deneyin.");
      console.error("Clipboard error:", err);
    }
  };

  // ✅ Copy all codes
  const copyAllCodes = async () => {
    const joined = codes.join(", ");
    await safeCopyToClipboard(joined);
    setCopied(true);
    toast.success("Tüm kodlar panoya kopyalandı!");
    setTimeout(() => setCopied(false), 2000);
  };

  // ✅ Copy single code
  const copySingleCode = async (code, index) => {
    await safeCopyToClipboard(code);
    setCopiedIndex(index);
    toast.success(`Kod kopyalandı: ${code}`);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  return (
    <div className="generated-codes">
      <div className="generated-codes-header">
        <h4>Oluşturulan Kodlar</h4>
        <button
          className={`copy-btn ${copied ? "copied" : ""}`}
          onClick={copyAllCodes}
          disabled={copied}
        >
          {copied ? "Kopyalandı ✓" : "Tümünü Kopyala"}
        </button>
      </div>

      <div className="codes-grid">
        {codes.map((code, index) => (
          <div
            key={index}
            className={`code-item ${
              copiedIndex === index ? "copied-single" : ""
            }`}
            onClick={() => copySingleCode(code, index)}
            title="Kodu kopyalamak için tıklayın"
          >
            {code}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneratedCodes;
